import { PropertyGroup } from "../property-group";
import { seriesProperty } from "./series-property";
import { nameProperty } from "./name-property";
import { crystalColorProperty } from "./crystal-color-property";
import { weaponVariantProperty } from "./weapon-variant-property";

export const staticGroup = new PropertyGroup("Static", [nameProperty, crystalColorProperty, seriesProperty, weaponVariantProperty])
